const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconST(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-T",
    x: 0,
    y: 0.002,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-T1",
    serifid: "iconS-T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.084,3.002l0,4.871l-0.478,0c-0.283,-1.124 -0.597,-1.931 -0.942,-2.422c-0.345,-0.492 -0.819,-0.883 -1.421,-1.175c-0.336,-0.159 -0.924,-0.239 -1.765,-0.239l-1.341,-0l0,13.885c0,0.92 0.051,1.495 0.153,1.726c0.102,0.23 0.301,0.431 0.597,0.604c0.297,0.172 0.701,0.258 1.215,0.258l0.597,0l0,0.492l-9.425,-0l0,-0.492l0.598,0c0.522,0 0.942,-0.093 1.261,-0.278c0.23,-0.124 0.411,-0.337 0.544,-0.638c0.097,-0.212 0.146,-0.769 0.146,-1.672l0,-13.885l-1.301,-0c-1.212,-0 -2.093,0.257 -2.641,0.77c-0.77,0.717 -1.257,1.739 -1.461,3.066l-0.504,0l-0,-4.871l16.168,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconST);
export default __webpack_public_path__ + "static/media/iconS-T.b0a527ac30f6ffbb01826e3b7eb7f69b.svg";
export { ForwardRef as ReactComponent };